






















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import HomeFooter from "@/components/footer.vue";
import HomeHeader from "@/components/header.vue";
import { User } from "../interfaces/user";
import { AuthService } from "../services/authService";
import RegisterButton from "@/components/customActions/registerButton.vue";

@Component({ components: { HomeFooter, HomeHeader, RegisterButton } })
export default class Test extends Vue {
    public steppermodel: number = 1;
    public validForm: boolean = false;

    public questions: Array<{ title: string; answer: string }> = [
        { title: "test.question1", answer: "" },
        { title: "test.question2", answer: "" },
        { title: "test.question3", answer: "" },
        { title: "test.question4", answer: "" },
        { title: "test.question5", answer: "" },
        { title: "test.question6", answer: "" },
    ];

    public setStep() {
        if (this.user) {
            if (this.$auth.isAuthenticated) {
                this.steppermodel = 2;
            }
            if (
                this.getCookie("step-completed") == "2" &&
                this.steppermodel == 2
            ) {
                this.steppermodel = 3;
            }
            if (this.user.permissions?.includes("tester")) {
                this.steppermodel = 4;
            }
        }
    }

    @Watch("$store.state.user")
    public watcher() {
        this.setStep();
    }

    public mounted() {
        this.setStep();
    }

    public get user(): User | null {
        return this.$store.state.user;
    }
    public get rules(): { [key: string]: (v: string) => boolean | string } {
        return {
            required: v => !!v || "Required.",
            notEmpty: v => v.length > 0 || "Message too short",
        };
    }

    public getCookie(name: string): string | null {
        const nameLenPlus = name.length + 1;
        return (
            document.cookie
                .split(";")
                .map(c => c.trim())
                .filter(cookie => {
                    return cookie.substring(0, nameLenPlus) === `${name}=`;
                })
                .map(cookie => {
                    return decodeURIComponent(cookie.substring(nameLenPlus));
                })[0] || null
        );
    }

    public async formSubmitted() {
        const token = await this.$auth.getTokenSilently();
        await AuthService.testingUsecase(token, this.questions);
        if (this.getCookie("step-completed") == "2") {
            this.steppermodel = 3;
        }
    }
}
